export default __webpack_public_path__ + "7396b7cc545dac6ce197dc1065c0d238.png";